import { render, staticRenderFns } from "./ViewFileItem.vue?vue&type=template&id=4db98a73&"
import script from "./ViewFileItem.vue?vue&type=script&lang=js&"
export * from "./ViewFileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports